
const config_default = {
    COMPANY_ID:   3,
    HP:'https://www.thehousebeachbeautyclub.com/',
    API_AUTH:                   '/oauth/auth',
    API_LINE_PATH:              '/line/token',
    API_ACCOUNT_CREATE:         {url:'/account',method:'POST'},
    API_PAYMENT_CREATE:         {url:'/payment',method:'POST'},
    API_USER_DETAIL:            {url:'/members' ,method:'POST'},
    API_USER_PAYMENT:            {url:'/members/payments' ,method:'POST'},
    API_USER_PICTURE_UPDATE:   '/members/picture',
    API_USER_SCHEDULE:           '/members/schedules',

    PHOTOS : ["59f68b80ed1e5.png","5966335f498d4.png","1538293159.png","1544863731.png","1545618575.jpg","1545827840.png","1545836459.jpg","1546307383.jpg","1546311916.jpg"],

    WEEK_0 : '日',
    WEEK_1 : '月',
    WEEK_2 : '火',
    WEEK_3 : '水',
    WEEK_4 : '木',
    WEEK_5 : '金',
    WEEK_6 : '土'

}

const config_dev = {

    API_AUTH_PATH: 'http://localhost:9020',
    API_PATH: 'http://localhost:9030',
    BASE_URL: 'http://localhost:3000',
    API_EXTENTION: "",
    PAY_JP_KEY: 'pk_test_11a0bc179964f349ec438b3e',
    CALL_BACK_NEW: 'https://localhost:3000/signup',
    CALL_BACK_LOGIN: 'https://localhost:3000/club/login'
};

const config_production = {
  API_AUTH_PATH: 'https://bbcauth.cowzow.jp',
  API_PATH: 'https://bbcapi.cowzow.jp',
  BASE_URL: 'https://thehousehayama.com/club',
  API_EXTENTION: "",
  PAY_JP_KEY: 'pk_live_9fe31f5a705dcb5e3bbf5089',
  CALL_BACK_NEW: 'https://thehousehayama.com/club/signup',
  CALL_BACK_LOGIN: 'https://thehousehayama.com/club/login'
};


var config = {}

if(process.env.NODE_ENV == "development"){
  config = Object.assign(config_default,config_dev)
}else if(process.env.NODE_ENV == "production"){
  config = Object.assign(config_default,config_production)
}

export default config;



// WEBPACK FOOTER //
// ./src/config.js